import { APP_GOOGLE_URL, APP_STORE_URL } from "@/constants/app-store";

export function isAppleDevice(): boolean {
  return /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
}

/**
 * Store page for the current OS: App Store on iOS/iPadOS/macOS, Google Play everywhere else (Android, Windows, Linux).
 */
export function getAppStoreUrl(): string {
  return isAppleDevice() ? APP_STORE_URL : APP_GOOGLE_URL;
}
